import { getFormattedDates } from '@/legacy/core/utils/dom/getFormattedDate'

import { BodyP } from '../Typography'

export type CustomPublication = { label?: 'Publicado em' | 'Atualizado em'; articleDate?: string }

interface ArticleDateProps {
  builderPublicationDate?: number
  customPublication: CustomPublication
}

export function publicationDate({ customPublication, builderPublicationDate }: ArticleDateProps) {
  if (customPublication?.articleDate) {
    return `${customPublication.label}: ${getFormattedPublicationDate(
      customPublication.articleDate,
    )}`
  }
  return `Publicado em: ${getFormattedPublicationDate(builderPublicationDate)}`
}

export function getFormattedPublicationDate(dateFormatted?: string | number) {
  return getFormattedDates(dateFormatted)?.accessible || ''
}

export const ArticleDate = ({ builderPublicationDate, customPublication }: ArticleDateProps) => (
  <BodyP color="dark-high">{publicationDate({ customPublication, builderPublicationDate })}</BodyP>
)
